import './Spacer.scss';

const Spacer = (): JSX.Element => (
    <div className="spacer"></div>
);

export default Spacer;